/**
 * Created by Karol Kluska on 11.01.18.
 */

angular
  .module('app')
  .controller('parentIframeWatcherController', parentIframeWatcherController);

function parentIframeWatcherController(parentIframeData) {
  if ('parentIFrame' in window) {
    parentIframeData.enable = true;
    parentIFrame.getPageInfo(function (data) {
      parentIframeData.scrollTop = data.scrollTop;
      parentIframeData.offsetTop = data.offsetTop;
    });
  }
}
